function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import mem from "mem";
import { getMinMediaQueries, getExclusiveMediaQueries } from "./css";
import { getPath } from "./objectPath";

function _getColor(colorName, theme) {
  if (typeof colorName !== "string" || colorName === "transparent") {
    return null;
  }

  return getPath(theme.colors, colorName);
}

function _getTextStyleCSS(textStyle, theme) {
  if (typeof textStyle !== "string") {
    return null;
  }

  var boldCSS = theme.textStyles["".concat(textStyle, ".bold")];
  return _objectSpread(_objectSpread({}, theme.textStyles[textStyle]), boldCSS && {
    "& strong": boldCSS,
    "& b": boldCSS
  });
}

function _getSpaceValue(space, theme) {
  if (typeof space === "number") {
    return theme.space[space] || "0px";
  }

  if (typeof space !== "string") {
    return null;
  }

  var parts = space.split(/\s+/).filter(Boolean);

  if (parts.length < 1 || parts.length > 4) {
    return null;
  }

  return parts.map(function (n) {
    if (n === "auto") {
      return n;
    }

    if (n[0] === "-") {
      var pxValue = theme.space[n.slice(1)];
      return pxValue ? "-".concat(pxValue) : "0px";
    }

    return theme.space[n] || "0px";
  }).join(" ");
}

function memoizeGetCSS(theme) {
  var result = {};

  for (var key in theme) {
    if (typeof theme[key].getCSS === "function") {
      var _theme$key = theme[key],
          getCSS = _theme$key.getCSS,
          rest = _objectWithoutProperties(_theme$key, ["getCSS"]);

      var memoizedGetCSS = mem(getCSS, {
        cacheKey: JSON.stringify
      });
      result[key] = _objectSpread({
        getCSS: memoizedGetCSS
      }, rest);
    } else {
      result[key] = theme[key];
    }
  }

  return result;
}

export function enhanceTheme(theme) {
  theme = memoizeGetCSS(theme);
  return _objectSpread(_objectSpread({}, theme), {}, {
    minMediaQueries: getMinMediaQueries(theme.breakpoints),
    exclusiveMediaQueries: getExclusiveMediaQueries(theme.breakpoints),
    getColor: function getColor(color) {
      return _getColor(color, theme);
    },
    getTextStyleCSS: function getTextStyleCSS(textStyle) {
      return _getTextStyleCSS(textStyle, theme);
    },
    getSpaceValue: function getSpaceValue(space) {
      return _getSpaceValue(space, theme);
    }
  });
}